import {TranslationElement} from 'client/services/translation-element';

import {Translation} from 'client/models/language/types';

/**
 * interpolate - helper for translations for adding variable inside translation string
 * @param template - string with special characters for replacing them, example 'Hello {{name}} {{surname}}'
 * @param map - object with variables, example: `{name: 'John', surname: 'Smith'}`
 */
export const interpolate = (
  template: string | TranslationElement,
  map: Record<string, Translation | number>,
): Translation => {
  const stringTemplate = template.toString();
  return Object.entries(map).reduce((acc, [key, value]) => {
    return acc.replace(`{{${key}}}`, String(value));
  }, stringTemplate);
};
